<script type="text/javascript">
import Vue from 'vue';
import axios from 'axios';
import app from '@/main';

const birthplaceList = [
    '北京市',
    '天津市',
    '上海市',
    '重庆市',
    '河北省',
    '山西省',
    '辽宁省',
    '吉林省',
    '黑龙江省',
    '江苏省',
    '浙江省',
    '安徽省',
    '福建省',
    '江西省',
    '山东省',
    '河南省',
    '湖北省',
    '湖南省',
    '广东省',
    '海南省',
    '四川省',
    '贵州省',
    '云南省',
    '陕西省',
    '甘肃省',
    '青海省',
    '台湾省',
    '内蒙古自治区',
    '广西壮族自治区',
    '西藏自治区',
    '宁夏回族自治区',
    '新疆维吾尔自治区',
    '香港特别行政区',
    '澳门特别行政区'
];

const nationList = [
    '汉族',
    '阿昌族',
    '白族',
    '保安族',
    '布朗族',
    '布依族',
    '朝鲜族',
    '达翰尔族',
    '傣族',
    '德昂族',
    '东乡族',
    '侗族',
    '独龙族',
    '俄罗斯族',
    '鄂伦春族',
    '鄂温克族',
    '高山族',
    '哈尼族',
    '哈萨克族',
    '赫哲族',
    '回族',
    '基诺族',
    '京族',
    '景颇族',
    '柯尔克孜族',
    '拉祜族',
    '黎族',
    '傈僳族',
    '珞巴族',
    '满族',
    '毛南族',
    '么佬族',
    '门巴族',
    '蒙古族',
    '苗族',
    '纳西族',
    '怒族',
    '普米族',
    '羌族',
    '撒拉族',
    '畲族',
    '水族',
    '塔吉克族',
    '塔塔尔族',
    '土家族',
    '土族',
    '佤族',
    '维吾尔族',
    '乌孜别克族',
    '锡伯族',
    '瑶族',
    '彝族',
    '仡佬族',
    '裕固族',
    '藏族',
    '壮族'
];

const zodiacList = ['鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊', '猴', '鸡', '狗', '猪'];
const constellationList = [
    '白羊座',
    '金牛座',
    '双子座',
    '巨蟹座',
    '狮子座',
    '处女座',
    '天秤座',
    '天蝎座',
    '射手座',
    '摩羯座',
    '水瓶座',
    '双鱼座'
];

const serviceModelList = [
    { id: '1', name: '保洁' },
    { id: '2', name: '保姆' },
    { id: '3', name: '品类' }
];

// 服务者标签字典
const tagsList = ['普通', '花王3H', '花王8H', '花王品类','希望树保洁','希望树品类'];

export default {
    nationList,
    zodiacList,
    constellationList,
    birthplaceList,
    serviceModelList,
    tagsList
};
</script>